import { css } from 'emotion'

export const LabelListStyles = css`
  > li {
    margin-top: 8px;
  }
`
